module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slideUp"
    }
  }, [(_vm.active) ? _c('div', {
    attrs: {
      "id": "proximity"
    }
  }, [_c('div', {
    staticClass: "proximity__header"
  }, [_c('div', {
    staticClass: "proximity__header-content"
  }, [_c('div', {
    staticClass: "header__title"
  }, [_c('svg', {
    staticClass: "icon icon-map",
    attrs: {
      "aria-hidden": "true",
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xlink:href": "#icon-map"
    }
  })]), _vm._v("\n          A proximité\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "distance"
  }, [_vm._v(_vm._s(_vm.radius) + " kilomètre(s)")])]), _vm._v(" "), _c('ul', {
    staticClass: "group-buttons"
  }, [_c('li', [_c('button', {
    on: {
      "click": _vm.expandProximity
    }
  }, [(_vm.expand) ? _c('svg', {
    staticClass: "icon icon-reduce",
    attrs: {
      "aria-hidden": "true",
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xlink:href": "#icon-reduce"
    }
  })]) : _c('svg', {
    staticClass: "icon icon-expand",
    attrs: {
      "aria-hidden": "true",
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xlink:href": "#icon-expand"
    }
  })])])]), _vm._v(" "), _c('li', [_c('button', {
    on: {
      "click": _vm.closeProximity
    }
  }, [_c('svg', {
    staticClass: "icon icon-close",
    attrs: {
      "aria-hidden": "true",
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xlink:href": "#icon-close"
    }
  })])])])])]), _vm._v(" "), (_vm.expand) ? _c('div', {
    staticClass: "proximity__content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radius),
      expression: "radius"
    }],
    attrs: {
      "type": "range",
      "min": _vm.rangeMin,
      "max": _vm.rangeMax,
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.radius)
    },
    on: {
      "change": _vm.isInRange,
      "__r": function($event) {
        _vm.radius = $event.target.value
      }
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('p', [_vm._v("N'afficher que ces catégories (optionnel):")]), _vm._v(" "), _vm._l((_vm.categories), function(cat) {
    return _c('div', {
      staticClass: "form__row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCat),
        expression: "selectedCat"
      }],
      attrs: {
        "type": "checkbox",
        "id": ((cat.id) + "-" + (cat.slug))
      },
      domProps: {
        "value": cat.id,
        "checked": true,
        "checked": Array.isArray(_vm.selectedCat) ? _vm._i(_vm.selectedCat, cat.id) > -1 : (_vm.selectedCat)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedCat,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = cat.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedCat = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedCat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedCat = $$c
          }
        }, function($event) {
          return _vm.getCats()
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ((cat.id) + "-" + (cat.slug))
      }
    }, [_vm._v(_vm._s(cat.name))])])
  })], 2)]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43257210!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Proximity.vue
// module id = 140
// module chunks = 2